import {
  //Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  Snackbar,
  Slide,
  Typography,
} from "@mui/material";
import Axios from "axios";
import MuiAlert from "@mui/material/Alert";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import CircularProgressWithLabel from "../../Components/CircularProgress/CircularProgressWithLabel";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import generatePayPremuimReqBody from "../../Utilities/LifeInsuranceRequestBodies/PayPremuimReqBodies/payPremuimReqBody";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

const LifePaymentOptions = () => {
  const [msgForSMSButton, setMsgForSMSButton] = useState(
    "Send payment link to customer"
  );
  const [savedValidate, setSavedValidate] = useState({});
  const [clickedPayHere, setClickedPayHere] = useState(false);
  const [transferData, setTransferData] = useState({});
  const [planData, setPlanData] = useState({});
  const [sendSMS, setSendSMS] = useState(false);
  const [nextButtonStatus, setNextButtonStatus] = useState(false);

  const { id } = useParams();
  const { state } = useLocation();
  console.log("sss", state);
  const { values } = state;

  const navigate = useNavigate();

  const productIdArray = id.split("*");
  //const productRef = productIdArray[0]
  const transId = productIdArray[0];
  const validateFormid = productIdArray[1];

  const payHere = () => {
    setClickedPayHere(true);
    let domainFrontEnd = "";
    let domainDjango = "";

    if (window.location.hostname === "localhost") {
      domainFrontEnd = process.env.REACT_APP_LOCAL_FRONT_END;
      domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domainFrontEnd = process.env.REACT_APP_PRODUCTION_FRONT_END;
      domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domainFrontEnd = process.env.REACT_APP_UAT_FRONT_END;
      domainDjango = process.env.REACT_APP_UAT_DJANGO;
    }

    console.log("vvv", values);

    /*  let paymentReq = {
      ...values,
      //["ReturnURL"]: `${domainFrontEnd}/lifeInsurance/paymentStatus/${transId}*${validateFormid}`,
      ["ReturnURL"]: `${domainFrontEnd}/lifeInsurance/paymentStatus/`,

    }; */

    //let ReturnURL = `${domainFrontEnd}/lifeInsurance/paymentStatus/`
    //    let ReturnURL = `http://65.0.70.70/lifeInsurance/paymentStatus/${transId}*${validateFormid}`;
    let ReturnURL = `${domainFrontEnd}/lifeInsurance/paymentStatus/${transId}*${validateFormid}`;

    let paymentReq = generatePayPremuimReqBody(savedValidate, ReturnURL);
    //let paymentReq = { ...values, ['ReturnURL']: 'https://google.com'}
    console.log("return url", paymentReq);

    console.log("return url append", JSON.stringify(paymentReq));

    Axios.post(
      `${domainDjango}/api/life-insurance/pay-premium/${transferData.A_id}/`,
      JSON.stringify(paymentReq)
    )
      .then((response) => {
        console.log(response, "response in pay premium");
        if (response.data.ResultSet.ResponseCode === "200") {
          setClickedPayHere(false);

          window.open(`http://${response.data.ResultSet.Response.PaymentUrl}`);
        } else {
          setClickedPayHere(false);
          //alert(response.data.ResultSet.ResponseMsg);
        }
      })
      .catch((e) => {
        console.log("err", e);
      });
  };

  const sendLink = () => {
    console.log("clicked send", nextButtonStatus);
    let domainDjango = "";
    if (window.location.hostname === "localhost") {
      domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domainDjango = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.get(
      `${domainDjango}/api/send-payment-link/${transferData.A_id}/${transferData.Acuvisor_product_id}/${id}`
      //`http://127.0.0.1:8000/api/send-payment-link/${transferData.A_id}/${transferData.Acuvisor_product_id}`
    ).then((response) => {
      //console.log('fffss', response)
      if (response.data[0].status && response.data[1].status) {
        setSendSMS(true);
        setMsgForSMSButton("A sms will be sent to the customer");
      }
      console.log("data", response.data);
    });
  };
  const backButtonHandler = () => {
    navigate(-1);
  };

  if (Object.keys(savedValidate).length > 0) {
    console.log(savedValidate.Request.Proposal.Plan, "Savedvalidate ");
  }

  const getValidateFormDetails = () => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.get(
      `${domain}/api/life-insurance/get-validate-proposal/${validateFormid}/`
    ).then((response) => {
      // setTransferData(response.data)
      console.log(response, "Savedvalidate resp");
      setSavedValidate(response.data);
      //setPlanData(response.data.Request.Proposal.Plan)
    });
  };

  const getTransferData = () => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.get(`${domain}/api/shriram/plp-validate-response/${transId}/`).then(
      (response) => {
        setTransferData(response.data);
        //checkPaymentStatus(response.data.A_id);
        console.log("trans of pay premium", response);
      }
    );
  };

  const getPaymentStatusData = (userId, appNo, A_id) => {
    // setLoading(false);
    let reqBody = {
      UserID: userId,
      //ApplicationNo: appNo,
      ApplicationNo: appNo,
    };
    console.log("requestBody", reqBody);

    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.post(
      `${domain}/api/life-insurance/payment-status/${A_id}/`,
      reqBody
    ).then((response) => {
      if (response.status === 200) {
        console.log("response from payment statii", response);
        let paymentStatus = {
          //...response.data.ResultSet.Response,
          //'TxnRef':response.data.ResultSet.TxnRef,
          TransactionDate: response.data.ResultSet.Response.TranasactionDate,
          //"TransactionRefNo": response.data.ResultSet.TxnRef,
          TransactionRefNo: response.data.ResultSet.Response.TranasactionID,
          //"TransationAmount":
        };
        //setApplicationStatus(paymentStatus);
        //setTransStatus(response.data.ResultSet.Response.PaymentStatus)
        //setLoading(true);

        if (response.data.ResultSet.Response.PaymentStatus === "Successful") {
          //setRefNext(true);
          Swal.fire({
            icon: "success",
            title: "Your Transaction is successfull",
            //text: '',
            position: "center",
          });
          let updateTransferData = {
            ...transferData,
            //TransactionId: TransactionId,
            payment: {...paymentStatus}
          };
          Axios
          .put(
            `${domain}/api/shriram/plp-validate-response/${transId}/`,
            updateTransferData
          )
          .then((response) => {
            console.log('dfdff',response)
            if (response.status === 200) {
              console.log("response in validate updated trans", response);
          setNextButtonStatus(true);
             
              // setTransferData(response.data);
            }
          }).catch(e=>{
            console.log('eer',e)
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Check the status again After 10mins",
            //text: '',
            position: "center",
          });
        }
      }
    });
  };

  const checkPaymentStatus = (A_id) => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.get(`${domain}/api/check-status/${A_id}/`).then((response) => {
      console.log("check Status", response);

      if (response.data.policyStatus === 7) {
        setNextButtonStatus(true);
        let userId = transferData.UserID;
        let appNo = transferData.ApplicationNo;
        getPaymentStatusData(userId, appNo, A_id);

        Swal.fire({
          icon: "success",
          title: "Your Transaction is successfull",
          //text: '',
          position: "center",
        }).then((result) => {
          console.log("swl", result);
          /* if (result.isConfirmed) {
            navigate(
              `/life-insurance/paypremium/${transferData.payment_config_id}*${transId}*${validateFormid}`
            );
          } */
        });
      }
    });
  };

  const handleCloseSlack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSendSMS(false);
  };

  const nextHandler = () => {
    navigate(`/lifeInsurance/paymentStatus/${transId}*${validateFormid}`);
  };


  useEffect(() => {
    getValidateFormDetails();
    getTransferData();

    return () => {};
  }, []);

  return (
    <>
      <div>
        <div className="header-section">
          <CategoryHeader title="Life Insurance" />
        </div>
        {Object.keys(savedValidate).length > 0 && (
          <Container
            style={{ marginTop: 10, marginBottom: 10 }}
            maxWidth="sm md lg"
          >
            <Card className="card-section" sx={{ minWidth: 275, marginTop: 5 }}>
              <Box sx={{ display: "flex", marginBottom: 4 }}>
                {/*  <img className="bg-white img-thumbnail rounded" width={100} height={100} src={responseData.logo} /> */}
                <Box style={{ margin: 16 }}>
                  <Typography></Typography>
                  <Typography></Typography>
                </Box>
              </Box>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Typography>Proposer Name:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography style={{ textTransform: "capitalize" }}>
                      <strong>
                        {savedValidate.Request.Proposal.Proposer.FirstName}
                      </strong>
                      <strong>
                        &nbsp;
                        {savedValidate.Request.Proposal.Proposer.MiddleName}
                      </strong>
                      <strong>
                        &nbsp;
                        {savedValidate.Request.Proposal.Proposer.LastName}
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography>Policy Type:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>
                      <strong></strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography>Number of Insured(s):</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography> 1</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography></Typography>
                  </Grid>
                  <hr />
                  <Grid item xs={3}></Grid>
                  <Grid item xs={6} color="text.primary" style={{}}>
                    <Typography>
                      <b>Premium Details</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={8}>
                    <Typography>Policy Premium:</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>
                      <b className="rupee_symp">
                        &#8377; {savedValidate.Request.Proposal.Plan.Premium}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>Tax On Premium:</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>
                      <b className="rupee_symp">
                        &#8377; {savedValidate.Request.Proposal.Plan.GST}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>Gross premium:</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>
                      <b className="rupee_symp">
                        &#8377;{" "}
                        {savedValidate.Request.Proposal.Plan.TotalPremium}
                      </b>
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <div className="button-section">
              {sendSMS ? (
                <div>
                  <div>
                    <button
                      className="pay-btn "
                      //type="button"
                      onClick={() =>
                        // checkPaymentStatus(transferData.A_id)
                        //getPaymentStatusData(transferData.UserID,'BCE8A8D85CA47E0',transferData.A_id)
                        getPaymentStatusData(
                          transferData.UserID,
                          transferData.ApplicationNo,
                          transferData.A_id
                        )
                      }
                    >
                      Check Status
                    </button>
                  </div>
                  <div>
                    {nextButtonStatus ? (
                      <button
                        className="pay-btn "
                        type="button"
                        onClick={nextHandler}
                      >
                        Next
                      </button>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              ) : (
                <div>
                  <div>
                    <button
                      className="payment-btn"
                      type="button"
                      onClick={sendLink}
                      disabled={
                        msgForSMSButton === "A sms will be sent to the customer"
                          ? true
                          : false
                      }
                    >
                      {msgForSMSButton}
                    </button>
                    <Snackbar
                      open={sendSMS}
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      autoHideDuration={5000}
                      TransitionComponent={TransitionLeft}
                      onClose={handleCloseSlack}
                    >
                      <Alert severity="success" onClose={handleCloseSlack}>
                        A sms will be sent to the customer
                      </Alert>
                    </Snackbar>
                  </div>
                  <div>
                    {clickedPayHere ? (
                      <Box
                        className="mx-auto"
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress
                          size={48}
                          sx={{
                            color: "red",
                          }}
                        />
                      </Box>
                    ) : (
                      <button
                        className="pay-btn "
                        type="button"
                        onClick={payHere}
                      >
                        Pay here
                      </button>
                    )}
                  </div>
                </div>
              )}

              <div>
                <button
                  className="back-btn"
                  type="button"
                  onClick={backButtonHandler}
                >
                  Back
                </button>
              </div>
            </div>
          </Container>
        )}
      </div>
    </>
  );
};

export default LifePaymentOptions;
